import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import { clearEntitlements } from 'data/entitlements/entitlementsUtils';

import { featureFlagsIdentifyUser } from 'utils/featureFlags/identify';
import { getLogger } from 'utils/logger';
import { cancelTokenSource } from 'utils/axiosFactory';
import { appRefreshAll } from 'data/app/actions';
import { loadPersistedDatasetData } from 'data/persist/actions';

import * as actions from './actions';
import { clearAuthSession, saveAuthSession } from './storage';
import { clearGlobalCaches } from './caches';

const log = getLogger('utils/auth/sagas');

export function* authLogin(action): Generator<*, *, *> {
  const { authSession, reload, location } = action.payload;
  log.info('Auth login...', authSession, reload, location);

  // save the auth session locally so it survives a reload
  yield call(() => saveAuthSession(authSession));

  if (reload) {
    clearGlobalCaches();

    log.info('Hard Redirecting to', location);

    // eslint-disable-next-line no-return-assign
    yield call(() => (window.location.href = location));
  } else {
    // if we are not reloading, force update to LD on custom user attributes
    yield call(() => featureFlagsIdentifyUser(authSession));

    // TODO: remove loadPersistedDatasetData once Quicken stop using credentials blob for Wells Fargo
    yield put(loadPersistedDatasetData());
    yield put(appRefreshAll({context: 'init'}));

    log.info('Redirecting to', location);
    if(location){
      yield put(replace(location));
    }
  }
}

export function* persistAuthSession({ payload: authSession }): Generator<*, *, *> {
  log.info('Peristing Refreshed OAuth Token...', authSession);

  // save the auth session locally so it survives a reload
  yield call(() => saveAuthSession(authSession));
}

export function* getAuthLoginActionWatcher() {
  yield takeLatest(actions.authLogin, authLogin);
}

export function* authLogoutWatcher() {
  yield takeEvery(actions.authLogout, function* _authLogout(action) {
    log.info('Auth Logout...', action.payload);

    // clear axios requests queue
    cancelTokenSource.cancel('Operation cancelled by logout.');

    // clear the auth session locally and global caches
    //
    clearAuthSession();
    clearEntitlements();
    clearGlobalCaches();

    // cancel sagas
    // yield cancel(sagaTasks);

    // clearing state & redirecting happens in app-reducer
  });
}

export function* persistAuthSessionWatcher() {
  yield takeLatest(actions.persistAuthSession, persistAuthSession);
}

// for loading watcher sagas
export default [
  getAuthLoginActionWatcher,
  authLogoutWatcher,
  persistAuthSessionWatcher,
];
